import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-create-ur-store',
  templateUrl: './create-ur-store.component.html',
  styleUrls: ['./create-ur-store.component.css']
})
export class CreateUrStoreComponent implements OnInit {
  form: FormGroup;

  homeData: any = {};
  categories: any[] = [];
  cities: any[] = [];

  lat = 0;
  lng = 0;
  zoom = 15;

  constructor() { }

  ngOnInit(): void {
  }
  addRequest() {

  }
}
